export default Object.freeze({
    Single: 'Single',
    Multi: 'Multi',
    Grid: 'Grid',
    OpenText: 'OpenText',
    Numeric: 'Numeric',
    OpenTextList: 'OpenTextList',
    NumericList: 'NumericList',
    Info: 'Info',
    Date: 'Date',
    EmailOpen: 'EmailOpen',
    Ranking: 'Ranking',
    HorizontalRatingScaleSingle: 'HorizontalRatingScaleSingle',
    GridBarsSingle: 'GridBarsSingle',
    StarRatingSingle: 'StarRatingSingle',
    HorizontalRatingScale: 'HorizontalRatingScale',
    GridBars: 'GridBars',
    StarRating: 'StarRating',
    Grid3d: 'Grid3d',
    GeoLocation: 'GeoLocation',
    DynamicQuestionPlaceholder: 'DynamicQuestionPlaceholder',
    ImageUploader: 'ImageUploader',
    VideoCapture: 'VideoCapture',
    AudioCapture: 'AudioCapture',
    CodeCapture: 'CodeCapture',
    Login: 'Login',
    Telephone: 'Telephone',
    Hierarchy: 'Hierarchy',
    SearchableSingle: 'SearchableSingle',
    SearchableMulti: 'SearchableMulti',
});
